<template>
  <filters-form
    :initial="initial"
    :scrollable="scrollable"

    :items="items"
    :loading="loading"
    :filters="filters"

    :schema="schema"
    :payload="payload"

    :actions="actions"
    :per-page="perPage"

    @reload="reloadKind"
  />
</template>

<script>
  import { mapState } from 'vuex';

  import form from '@cordel/helpers/form/mixin';
  import optionsHelper from '@cordel/helpers/form/select/options';

  import FiltersForm from '@sdk/components/Filters/Form.vue';

  // eslint-disable-next-line import/no-extraneous-dependencies
  import preload from '@/helpers/mixins/preload';

  // eslint-disable-next-line import/no-extraneous-dependencies
  import { INITIAL_VEHICLE_FILTERS as INITIAL } from '@/store/modules/used-vehicles';

  import payloadGenerator from './payload';
  import schemaGenerator from './schema';

  import {
    STORE_ID,
  } from './fields';

  export default {
    name: 'VehiclesUsedFilters',
    components: {
      FiltersForm,
    },
    mixins: [
      form,
      preload,
    ],
    props: {
      scrollable: {
        type: Boolean,
        default: true,
      },
      perPage: {
        type: Number,
        default: null,
      },
    },
    data() {
      return {
        schema: schemaGenerator(),
        payload: payloadGenerator(),

        initial: {},

        actions: {
          filter: 'usedVehicles/filter',
          clear: 'usedVehicles/clear',
          list: 'usedVehicles/list',
        },
      };
    },
    computed: {
      ...mapState([
        'usedVehicles',
        'stores',
      ]),

      items() {
        return this.usedVehicles.list.items;
      },
      loading() {
        return this.usedVehicles.list.loading;
      },
      filters() {
        return this.usedVehicles.list.filters;
      },
    },
    beforeMount() {
      this.initial = { ...INITIAL };
    },
    mounted() {
      this.getStores();
    },
    methods: {
      reloadStores(filters) {
        this.getStores(false, filters);
      },
      getStores(cached, payload) {
        this.updateLoading(STORE_ID, true);
        this.preloadStores(cached, payload).then(this.gotStores);
      },
      gotStores() {
        this.updateLoading(STORE_ID, false);
        this.updateOptions(STORE_ID, optionsHelper(this.stores.list.items));
      },
    },
  };
</script>
